import { render } from "./UserForm.vue?vue&type=template&id=8eae7eb6&scoped=true&ts=true"
import script from "./UserForm.ts?vue&type=script&lang=ts"
export * from "./UserForm.ts?vue&type=script&lang=ts"

import "./UserForm.scss?vue&type=style&index=0&id=8eae7eb6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eae7eb6"]])

export default __exports__